<template>
  <div class="w-full mt-10">
    <h2 class="text-565656 fsize16 font-semibold border-b pb-4">
      Recommendation
    </h2>

    <swiper :options="recOption" class="related-product-swiper mt-6">
      <swiper-slide
        v-for="(item, index) in brandKit"
        :key="index"
        class="cursor-pointer"
      >
        <!-- Item Image -->
        <div
          class="text-center cursor-pointer rounded-4px"
          @click="handleClick('social', item)"
        >
          <img
            :src="showImage(item.image)"
            class="object-cover w-full h-8rem rounded-4px"
            alt="banh"
          />
          <p class="font-medium text-dark truncate fsize12 mb-0 p-2">
            {{ item.name }}
          </p>
        </div>
      </swiper-slide>

      <!-- <div
                  class="swiper-button-prev cust-hidden"
                  slot="button-prev"
                ></div>
                <div
                  class="swiper-button-next cust-hidden"
                  slot="button-next"
                ></div> -->
    </swiper>
  </div>
</template>

<script>
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
export default {
  data() {
    return {
      recOption: {
        slidesPerView: 4.2,
        observer: true,
        observeParents: true,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4.2,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      brandKit: [],
    };
  },

  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;
      console.log(`${image_base_url}/${value}`, "imgurl");
      return value ? `${image_base_url}/${value}` : default_image;
    },
    handleClick(name, card) {
      this.$store.commit("studio/GET_SELECTED_CARD", card);
      this.$router.push({ name: name });
      console.log(card, "card name");
    },
  },
  computed: {
    ...mapState("studio", ["cardoptions"]),
  },
  mounted() {
    this.brandKit = this.cardoptions;
  },
};
</script>
